import React from 'react';
import useLabels from '@ubeya/shared/hooks/account/useLabels';
import { FlexMiddle } from '../../Flex';

const NO_LABEL_VALUE = -1;

const ShiftTypeChip = ({ value }) => {
  const { mappedLabels } = useLabels({ filterByBranch: false });

  const getTitle = (item) => (Number(item) === NO_LABEL_VALUE ? mappedLabels[null]?.title : mappedLabels[item]?.title);

  if (!Array.isArray(value)) {
    return <FlexMiddle>{getTitle(value) || value}</FlexMiddle>;
  }

  return <FlexMiddle>{value.map(getTitle).join(', ')}</FlexMiddle>;
};

export default ShiftTypeChip;
